import { useEffect, useMemo, useRef } from "react";
import { Route, Routes, useLocation } from "react-router";
import { PageContext } from "../PageContext";
import { useAsyncUpdateWithArgs } from "../../../util/useAsyncUpdate";
import { getMaterialFromIdSearchPayload } from "../../../schema/console/material";
import { ParseMaterial, rangesToString } from "../../../util/Materialperser";
import { useMaterialMasters } from "../../../util/useMaterialMasters";
import { MaterialSearchListPage } from "./MaterialSearchListPage";
import { MaterialStatusPage } from "./MaterialStatusPage";

export default function MaterialSearchRoute({ pageContext }: { pageContext: PageContext }) {
  const location = useLocation();
  // クエリ→検索パラメータの変換はメモ化（文字列が変わった時だけ再計算）
  const materialSearchParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return ParseMaterial(searchParams.get("searchParams") ?? "");
  }, [location.search]);

  // 初期化は空でOK。fetchは useEffect 側で起動する
  const [materials, updateMaterials] = useAsyncUpdateWithArgs(
    (requestData: getMaterialFromIdSearchPayload) =>
      pageContext.api.material.getFromIdSearch(requestData),
    { targetRanges: materialSearchParams }
  );

  // クエリ(searchParams)が変わったら都度フェッチする。materials の有無だけを見ていると
  // 既に非空の結果がある状態から別のクエリへ変わった際に再フェッチされないため、
  // 直近フェッチ済みの params を ref で保持して比較する。
  const lastFetchedParamsRef = useRef<string | null>(null);
  useEffect(() => {
    const paramsKey = rangesToString(materialSearchParams);
    if (lastFetchedParamsRef.current !== paramsKey) {
      lastFetchedParamsRef.current = paramsKey;
      updateMaterials({ targetRanges: materialSearchParams });
    }
  }, [materialSearchParams, updateMaterials]);

  // 材料マスタ(材料列・材料フィルタ用)。ログイン時取得済みだが画面単位で取り直す。
  const { materials: materialMasters, materialsById } = useMaterialMasters(pageContext.api);

  return (
    <Routes>
      <Route index element={<MaterialSearchListPage pageContext={pageContext} defaultParams={rangesToString(materialSearchParams)} materials={materials} onUpdate={updateMaterials} materialMasters={materialMasters} materialsById={materialsById} />} />
      <Route path=":id/" element={<MaterialStatusPage pageContext={pageContext} materials={materials} />} />
    </Routes>
  );
}
